import clsx from "clsx";
import React, { ButtonHTMLAttributes } from "react";

export type IconButtonProps = {
    children: React.ReactNode;
    shape?: "square" | "circle";
    size?: "small" | "medium" | "large";
    color?: "primary" | "secondary" | "tertiary";
    customColor?: string;
    variant?: "solid" | "outline" | "soft";
    className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function IconButton(props: IconButtonProps) {
    const {
        children,
        shape = "square",
        size = "medium",
        color = "primary",
        customColor,
        variant = "solid",
        className,
        ...rest
    } = props;
    return (
        <button
            className={clsx(
                className && className,
                "flex items-center justify-center cursor-pointer",
                shape === "square" ? "rounded-md" : "rounded-full",

                size === "small"
                    ? "w-[24px] h-[24px] text-sm"
                    : size === "medium"
                    ? "w-[32px] h-[32px] text-base"
                    : "w-[40px] h-[40px] text-base",

                color === "primary"
                    ? `${
                          variant === "soft"
                              ? "bg-star-gold/10 text-star-gold"
                              : "bg-star-gold text-black hover:bg-star-gold/80"
                      }`
                    : color === "secondary"
                    ? `${variant === "soft" ? "bg-n-20/10 text-n-20" : "bg-n-10 text-black"}`
                    : `${
                          variant === "soft"
                              ? "bg-n-20/10 text-n-20"
                              : "bg-n-20 text-black hover:bg-n-20/80"
                      }`,

                variant === "solid"
                    ? "border-none"
                    : variant === "outline"
                    ? "bg-transparent border"
                    : "bg-transparent",

                rest.disabled && "opacity-50",

                "transition-all duration-300 ease-in-out "
            )}
            {...rest}
        >
            {children}
        </button>
    );
}
